import type { GumballBalance, Season } from "../../api/types";
import { formatNumber } from "../../lib/format";

export function BankPanel({
  season,
  balance,
  coinsFromLeaders,
  canGive,
  onGive
}: {
  season: Season | null;
  balance: GumballBalance;
  coinsFromLeaders: number;
  canGive: boolean;
  onGive: () => void;
}) {
  return (
    <aside className="bank-panel" aria-label="Gumball bank">
      <header className="bank-panel__header">
        <span className="bank-panel__eyebrow">Gumball Bank</span>
        <h2 className="bank-panel__title">{season === null ? "No active season" : season.name}</h2>
        {season !== null && (
          <span className="bank-panel__status">
            {season.status === "active" ? "Active season" : season.status}
          </span>
        )}
      </header>
      <dl className="bank-panel__stats">
        <BankStat label="Coins from leaders" value={coinsFromLeaders} hint="granted this season" />
        <BankStat label="Coins left to spend" value={balance.available_coins} />
        <BankStat label="Gumballs given" value={balance.gumballs_given} />
        <BankStat label="Gumballs received" value={balance.gumballs_received} />
      </dl>
      <button
        type="button"
        className="bank-panel__cta"
        disabled={!canGive || season === null || season.status !== "active"}
        onClick={onGive}
      >
        Give gumballs
      </button>
      {season === null && (
        <p className="bank-panel__hint">Waiting for an active season — your admin can start one.</p>
      )}
      {season !== null && season.status !== "active" && (
        <p className="bank-panel__hint">This season is not active right now.</p>
      )}
    </aside>
  );
}

function BankStat({
  label,
  value,
  hint
}: {
  label: string;
  value: number;
  hint?: string;
}) {
  return (
    <div className="bank-panel__stat">
      <dt>{label}</dt>
      <dd>{formatNumber(value)}</dd>
      {hint !== undefined && <small>{hint}</small>}
    </div>
  );
}
